import { Supplier } from '../../../shared/types';
import { useGetSupplierRiskHistory } from '../../../hooks';
import RiskAssessmentHistory from '../../../shared/components/RiskAssessment/RiskAssessmentHistory';

const SupplierActivitiesTab = ({ riskAssessment }: Partial<Supplier>) => {
  const { data: riskHistory, isFetching } = useGetSupplierRiskHistory(
    riskAssessment?.id
  );

  return (
    <RiskAssessmentHistory riskHistory={riskHistory} loading={isFetching} />
  );
};

export default SupplierActivitiesTab;
